import loadable from '@loadable/component';
import { PropsWithChildren } from 'react';
import { LoadableFunctionalComponent } from '../../utils/index.ts';

export const ThemeProvider = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.ThemeProvider,
  fallback: <p>Загрузка...</p>,
}) as LoadableFunctionalComponent<PropsWithChildren<NonNullable<unknown>>>;
